import { all, takeEvery } from "redux-saga/effects";
import { createAction } from "typesafe-actions";
import { MenuActionTypes } from "./types";

export const menuAction = createAction(MenuActionTypes.MENU_ACTION, (payload) => payload)();

export function* menuSaga() {
  yield all([takeEvery(MenuActionTypes.MENU_ACTION, menuAction)]);
}
